import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MonitorOffIcon, ScissorsIcon, YoutubeIcon } from 'lucide-react';
export function AgitationSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-12 sm:py-24 px-4 bg-background relative border-y border-white/5" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid md:grid-cols-3 gap-8" data-id="element-17">
          <motion.div variants={itemVariants} className="bg-surfaceLight p-8 rounded-2xl border border-white/5" data-id="element-18">
            <div className="w-12 h-12 rounded-full bg-background flex items-center justify-center mb-6 border border-white/10" data-id="element-19">
              <MonitorOffIcon className="w-5 h-5 text-textMuted" data-id="element-20" />
            </div>
            <h3 className="font-serif text-xl mb-4 text-text" data-id="element-21">
              Desconexión Digital
            </h3>
            <p className="text-textMuted leading-relaxed" data-id="element-22">
              Pasamos el día pegados a las pantallas, estresados y desconectados
              de nuestras manos. Quieres un hogar que refleje tu estilo, pero el
              arte real es impagable.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-surfaceLight p-8 rounded-2xl border border-white/5" data-id="element-23">
            <div className="w-12 h-12 rounded-full bg-background flex items-center justify-center mb-6 border border-white/10" data-id="element-24">
              <YoutubeIcon className="w-5 h-5 text-textMuted" data-id="element-25" />
            </div>
            <h3 className="font-serif text-xl mb-4 text-text" data-id="element-26">
              Tutoriales Fallidos
            </h3>
            <p className="text-textMuted leading-relaxed" data-id="element-27">
              Intentas tutoriales gratuitos en YouTube y terminas con los dedos
              llenos de pegamento y una figura que da vergüenza colgar en la
              sala.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-surfaceLight p-8 rounded-2xl border border-white/5" data-id="element-28">
            <div className="w-12 h-12 rounded-full bg-background flex items-center justify-center mb-6 border border-white/10" data-id="element-29">
              <ScissorsIcon className="w-5 h-5 text-textMuted" data-id="element-30" />
            </div>
            <h3 className="font-serif text-xl mb-4 text-text" data-id="element-31">
              Material Desperdiciado
            </h3>
            <p className="text-textMuted leading-relaxed" data-id="element-32">
              Cartulina arruinada, cortes chuecos y frustración. El tiempo que
              perdiste dolió más que el dinero invertido en materiales.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}